import { render } from "./IndustrySelect.vue?vue&type=template&id=5a65be6e"
import script from "./IndustrySelect.vue?vue&type=script&lang=js"
export * from "./IndustrySelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__